export default __webpack_public_path__ + "static/media/card.d35108c2.svg";